const URL_PATTERN = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/i;

function hrefFor(url: string): string {
  return url.startsWith('www.') ? `http://${url}` : url;
}

export interface LinkedTextProps {
  text: string;
}

export function LinkedText({ text }: LinkedTextProps) {
  const parts = text.split(URL_PATTERN);

  return (
    <p>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: 분할된 조각은 고유 식별자가 없고 순서가 바뀌지 않는다
          <a key={`${part}-${index}`} href={hrefFor(part)} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          part
        ),
      )}
    </p>
  );
}
